import { RouteObject } from "react-router-dom-7"

import { globToTreeRoutes, layout } from "~/shared/lib/routing"
import { Page404 } from "~/shared/ui"
import { RouteErrorBoundary } from "~/domain/user-session"

export const routes: RouteObject[] = [
	layout(() => import("./layout"), [
		...globToTreeRoutes(import.meta.glob(["./routes/**/*/route.tsx"])),
		{ path: "*", Component: Page404 },
	].map(route => ({ ErrorBoundary: RouteErrorBoundary, ...route })))
]
